<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content" style="padding-bottom:0;">
        <el-form label-position="left" style="display: flex">
          <el-form-item :label="$t('CargoMsg.SourceCompany')" label-width="80px" style="width: 400px">
            <cargo-advance-select
              no="tenantId"
              :select-type="TYPE_NAMES.TENANT"
              :cache="false"
              filterable
              :show-custom-label-in-option="true"
              :custom-label="companyLabel"
              callback-method-type="value"
              @parentCallBack="filterTenantIdChangeHandler"
            />
          </el-form-item>
          <el-form-item label-width="0">
            <el-button no="1" type="primary" style="margin-left: 10px" @click="queryChargeScheme()">{{ $t('CargoMsg.QueryChargeScheme') }}</el-button>
            <el-button no="2" type="primary" style="margin-left: 10px" @click="showChargeSchemeDialog">{{ $t('CargoMsg.CopyChargeScheme') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2024040201"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="2024040202"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="queryChargeScheme"
          />
          <el-dialog
            v-el-drag-dialog
            :visible.sync="copyDialog.visible"
            :title="$t('CargoMsg.CopyChargeScheme')"
            width="400px"
            :close-on-click-modal="false"
          >
            <el-form label-position="left">
              <el-form-item :label="$t('CargoMsg.CopyToCompany')" label-width="100px">
                <cargo-advance-select
                  no="tenantId2"
                  :select-type="TYPE_NAMES.TENANT"
                  :cache="false"
                  filterable
                  :show-custom-label-in-option="true"
                  :custom-label="companyLabel"
                  :static-options="targetTenants"
                  callback-method-type="value"
                  @parentCallBack="p=>{copyDialog.tenantId=p}"
                />
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button no="3" type="primary" @click="copyChargeScheme">{{ $t('SeaExport.Confirm') }}</el-button>
              <el-button no="4" @click="closeDialog">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getAllChargeSchemeList, copyChargeSchemeToTenant } from '@/api/batchMove'
import { getAllTenant } from '@/api/auth'

export default {
  name: 'ChargeSchemeCopy',
  components: { CargoAdvanceSelect },
  data() {
    return {
      URL,
      chargeSchemeUuidList: [],
      tenants: [],
      targetTenants: [],
      searchConditions: {
        total: 0,
        pageNum: 100,
        pageSize: 0,
        tenantId: 0
      },
      copyDialog: {
        tenantId: 0,
        visible: false
      },
      gridApi: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 30, checkboxSelection: true,
          suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          width: 150
        }, {
          headerName: this.$t('baseInfo.partner.branchId'),
          field: 'branchName',
          colId: 'branchName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ProductName'),
          field: 'name',
          colId: 'name',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerStr',
          colId: 'customerStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierStr',
          colId: 'carrierStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'bookingAgentStr',
          colId: 'bookingAgentStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_TypeOfGoods'),
          field: 'cargoType',
          colId: 'cargoType',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingRouteArea'),
          field: 'region',
          colId: 'region',
          width: 100,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_EntryDate'),
          field: 'inputDate',
          colId: 'inputDate',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'effectiveDate',
          colId: 'effectiveDate',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'expiryDate',
          colId: 'expiryDate',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditStatus'),
          field: 'approvedState',
          colId: 'approvedState',
          width: 120,
          cellRenderer: (params) => {
            return this.approvedStateLabFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReviewTime'),
          field: 'dateApproved',
          colId: 'dateApproved',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_DescriptionOfPlan'),
          field: 'remark',
          colId: 'remark',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
          field: 'destinationAgentStr',
          colId: 'destinationAgentStr',
          hide: true,
          width: 200,
          tooltipValueGetter: (params) => params.value
        }]
    }
  },
  computed: {
    TYPE_NAMES() {
      return TYPE_NAMES
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  methods: {
    queryChargeScheme() {
      if (!this.searchConditions.tenantId) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.saveWarning'))
        return
      }
      const loading = getLoading4Cxt(this)
      getAllChargeSchemeList({
        tenantId: this.searchConditions.tenantId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize
      }).then(res => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.gridApi.clearFocusedCell()
      }).catch(() => {

      }).finally(() => {
        loading.close()
      })
    },
    // 审核状态
    approvedStateLabFun(value) {
      if (value === 0) {
        // 未审核
        return this.$t('CargoMsg.Cargo_Uncommitted')
      }
      if (value === 1) {
        // 已提交
        return this.$t('CargoMsg.Cargo_Submitted')
      }
      if (value === 2) {
        // 已审核
        return this.$t('CargoMsg.Cargo_Approved')
      }
      // 状态未知
      return this.$t('CargoMsg.Cargo_UnKnownStatus')
    },
    copyChargeScheme() {
      this.chargeSchemeUuidList = []
      if (!this.copyDialog.tenantId) {
        this.$message.warning(this.$t('CargoMsg.PleaseSelectTargetTenant'))
        return
      }
      const rows = this.gridApi.getSelectedRows()
      if (!(rows.length > 0)) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const row of rows) {
        this.chargeSchemeUuidList.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      copyChargeSchemeToTenant({
        chargeSchemeUuidList: this.chargeSchemeUuidList,
        sourceTenantId: rows[0].tenantId,
        targetTenantId: this.copyDialog.tenantId
      }).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.CopySuccessCount', [res.data]))
        }
      }).catch(() => {

      }).finally(() => {
        loading.close()
      })
      this.copyDialog.visible = false
    },
    showChargeSchemeDialog() {
      this.targetTenants = this.tenants.filter(p => p.id !== this.searchConditions.tenantId)
      this.copyDialog.visible = true
    },
    closeDialog() {
      this.copyDialog.visible = false
    },
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    filterTenantIdChangeHandler(value) {
      this.searchConditions.tenantId = value
    }
  }
}
</script>
